export default __webpack_public_path__ + "static/media/memories.e84e7a67.png";